import React from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import Select from 'react-select';
import Constants from '../../config/constants';
import RelationDataTable from '../datatable/RelationDataTable';
import Thumbnail from '../thumbnail/Thumbnail';
import { COLUMN_STYLE, getColumnStyle, searchData } from '../datatable/util';
import {
  addAirHandlingUnitToACCentral,
  removeAirHandlingUnitFromACCentral,
  addToBeCreatedAirHandlingUnit,
  removeToBeCreatedAirHandlingUnit,
} from '../../redux/ac_central/ac_central_actions';
import { searchAirHandlingUnitByText } from '../../redux/ac_central/air_handling_unit_actions';
import { defaultRejectHandler } from '../../utils/utility';

export class AirHandlingUnitDataTable extends React.Component {
  constructor(props) {
    super(props);
    const { t } = props;

    this.search = {
      pageSize: Constants.DATA_TABLE_PAGE_SIZE,
      page: null,
      sorted: null,
      filtered: null,
    };

    const textColumn = getColumnStyle(COLUMN_STYLE.text);
    const coeColumn = getColumnStyle(COLUMN_STYLE.coefficient);

    this.columns = [
      {
        Header: '',
        accessor: 'fan_coil.thumbnail',
        Cell: row => <Thumbnail img={row.value} />,
        ...getColumnStyle(COLUMN_STYLE.thumbnail),
      },
      {
        Header: () => <b>{t('name')}</b>,
        accessor: 'fan_coil.name',
        ...textColumn,
        entity: {
          list: (text, page) => searchAirHandlingUnitByText(text ,page)
            .then(response => response.data.map((fan_coil) => ({label: fan_coil.name, value: String(fan_coil.id), original: fan_coil}))),
          create: null,
        },
      },
      {
        id: 'coolingCapacity',
        Header: () => <b>{t('cooling capacity')}</b>,
        accessor: data => `${data.fan_coil.cooling_capacity} ${data.fan_coil.unit}`,
        ...coeColumn,
        width: 100,
      },
      {
        Header: () => <b>{t('power (kW)')}</b>,
        accessor: 'fan_coil.power_required',
        ...coeColumn,
        width: 100,
      },
    ];

    this.state = {
      isShowCreateAC: false,
    };
  }

  updateSortFilter(filter, state, category) {
    if (state) {
      this.search.pageSize = state.pageSize;
      this.search.page = state.page;
      this.search.sorted = state.sorted;
    }
    this.search.filtered = filter;
    if(filter!== undefined){
      this.setState({ search: filter })
    }
    this.setState({ categoryOption: category });
  }


  render() {
    const {
      categoryOption,
      selectedItem: item,
      search,
    } = this.state;

    const {
      acCentralId,
      filtered,
      filteredCount,
      isLoading,
      addAirHandlingUnit,
      removeAirHandlingUnit,
      isAirHandlingUnitAdding,
      isAirHandlingUnitRemoving,
      addToBeCreatedAirHandlingUnit,
      removeToBeCreatedAirHandlingUnit,
      mode,
      ahus,
      t,
    } = this.props;

    const accessor = (data) => data && data.fan_coil;

    const relationship = {
      create: (({ entityId, original}) => {
        if (mode === 'edit'){
          addAirHandlingUnit(acCentralId, entityId)
        }else{
          addToBeCreatedAirHandlingUnit(original, this.props.ahus)
        }
      }).bind(this),
      delete: (id, rel) => {
        if (mode === 'edit'){
          removeAirHandlingUnit(id, acCentralId)
        }else{
          removeToBeCreatedAirHandlingUnit(rel.fan_coil.id);
        }
      },
      isCreating: isAirHandlingUnitAdding,
      isDeleting: isAirHandlingUnitRemoving,
    };
    return (
      <div>
        <div style={{ backgroundColor: 'white' }}>
          <div className="filter-box" style={{ display: 'flex', padding: 20, marginBottom: 20 }}>
            <input
              className="text-search"
              style={{ width: 240, height: 36, margin: 10 }}
              type="text"
              onChange={event => this.updateSortFilter(event.target.value, null, categoryOption)}
              placeholder={t('search name')}
            />
            <Select
              className="react-select-container"
              classNamePrefix="react-select"
              style={{ width: 160, margin: 10 }}
              value={categoryOption}
              placeholder={t('category')}
              onChange={option => this.updateSortFilter(filtered, null, option)}
              options={[
                { value: 'all', label: t('all') },
                { value: 'public', label: t('public') },
                { value: 'private', label: t('private') },
              ]}
            />
          </div>
          <RelationDataTable
            columns={this.columns}
            data={searchData(search, categoryOption, ahus, accessor)}
            relationship={relationship}
            relationshipNameAccessor={item => item.fan_coil.name}
            classNamePrefix="select-central-unit-air-handling-unit"
            onActionDelete={item => this.setState({ isShowDeleteModal: true, selectedItem: item.original })}
            filteredCount={filteredCount}
            isLoading={isLoading}
            onFetchData={state => this.updateSortFilter(filtered, state, categoryOption)}
          />
        </div>
      </div>
    );
  }
}
const mapStateToProps = state => ({
  isAirHandlingUnitAdding: state.ac.central.isAirHandlingUnitAdding,
  isAirHandlingUnitRemoving: state.ac.central.isAirHandlingUnitRemoving,
});

const mapDispatchToProps = dispatch => ({
  addAirHandlingUnit: (acCentralId, ahuId) => defaultRejectHandler(dispatch(addAirHandlingUnitToACCentral(acCentralId, ahuId))),
  addToBeCreatedAirHandlingUnit: (fan_coil, tobecreatedairhandlingarry) => defaultRejectHandler(dispatch(addToBeCreatedAirHandlingUnit(fan_coil, tobecreatedairhandlingarry))),
  removeAirHandlingUnit: (acCentralAirHandlingUnitId, acCentralId) => defaultRejectHandler(dispatch(removeAirHandlingUnitFromACCentral(acCentralAirHandlingUnitId, acCentralId))),
  removeToBeCreatedAirHandlingUnit: (ahuId) => defaultRejectHandler(dispatch(removeToBeCreatedAirHandlingUnit(ahuId))),
});

export default translate('translations', { withRef: true })(
  connect(
    mapStateToProps,
    mapDispatchToProps,
    null,
    { withRef: true },
  )(AirHandlingUnitDataTable),
);



// WEBPACK FOOTER //
// ./src/components/ac_central/AirHandlingUnitDataTable.js